{
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password"
  },
  "auth_group": {
    "all": "All",
    "general_user": "General User",
    "manager": "Manager",
    "admin": "Admin",
    "designer": "Designer"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "construction": "We're currently under construction.",
    "working": " We're working on it. See you soon.",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "english": "English",
    "korean": "Korean"
  },
  "menu": {
    "home": "HOME",
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "orders": "Orders",
    "login": "Login",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "404": "404",
    "faq": "FAQ",
    "notice": "Notice",
    "users": "Users",
    "stores": "Stores",
    "jrs": "Flyer",
    "jrs-edit": "Flyer edit",
    "jrs-list": "Flyer list",
    "jrs-assessment": "Flyer assessment",
    "jrs-verification": "Flyer verification",
    "scraping": "Scraping",
    "promotions": "Events",
    "ads": "Ads",
    "jrs-ads": "Flyer Ads",
    "alarm-ads": "alarm Ads",
    "search-suggestion-ads": "Search Ads",
    "search-sns-ads": "Social Network Ads"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore",
    "create_user": "Create user",
    "update_user": "Update user"
  },
  "order": {
    "user_order_detail": "Customer order details",
    "ad_order_detail": "Store order details",
    "cancelReason": "Cancel Reason"
  },
  "table": {
    "number": "No",
    "name": "Name",
    "phone": "Phone",
    "email": "Email",
    "manager": "Manager",
    "registration_date": "Registration Date",
    "store_name": "Store Name",
    "address": "Address",
    "registered_manager": "Primary Admin",
    "additional_managers": "Additional Staff",
    "number_of_manager": "Total Admins"
  },
  "label": {
    "ad_title": "Ad Title",
    "authType": "Authorization Group",
    "date": "Date",
    "selection": "Selection",
    "name": "Name",
    "user_id": "User ID",
    "user_email": "User Email",
    "phone": "Phone",
    "user_permission": "User Permission",
    "company_name": "Company Name",
    "job_title": "Job Title",
    "store": "Store",
    "manager": "Manager",
    "product_name": "Product Name",
    "quantity": "Quantity",
    "price": "Price",
    "order_name": "Order Name",
    "order_number": "Order Number",
    "order_amount": "Total Amount",
    "order_status": "Order Status",
    "payment_company": "Payment Company",
    "note": "Note",
    "customer_information": "Customer Information",
    "product_information": "Product Information",
    "order_details": "Order Details",
    "store_information": "Store Information",
    "order_information": "Order Information",
    "sns_id": "SNS ID",
    "sns_type": "SNS Type",
    "sns_token": "SNS Token",
    "notification_token": "Notification Token"
  },
  "button": {
    "edit_image": "Edit Image",
    "edit_business_license": "Edit Business License",
    "add_store": "Add Store",
    "edit_store": "Edit Store",
    "close": "Close",
    "cancel": "Cancel",
    "showMore": "Show More",
    "readMore": "Show More",
    "cancelOrder": "Cancel Order",
    "viewReceipt": "View Receipt"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "settings": {
    "settings": "Settings",
    "theme": "Theme",
    "general_preferences": "General Preferences"
  },
  "validators": {
    "require": "This field is required.",
    "isNumber": "Please enter numbers only.",
    "save_change": "Save Changes",
    "no_image": "No Image"
  },
  "vuestic": {
    "select": "Select",
    "breadcrumbs": "Breadcrumbs",
    "toggleDropdown": "Toggle dropdown",
    "pagination": "Pagination",
    "goToTheFirstPage": "First Page",
    "goToPreviousPage": "Previous Page",
    "goToSpecificPage": "Go To Page",
    "goNextPage": "NextPage",
    "goLastPage": "LastPage",
    "close": "Close"
  }
}
